import styled from 'styled-components';
import { PrescriptionSectionGraphic } from '../PrescriptionSection.styles';

export const PHIBannerSectionGraphic = styled(PrescriptionSectionGraphic)`
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
